import React from 'react'
import { CampaignsTable } from '../components/campaigns/CampaignsTable'

export const Campaigns3 = ({}) => {
    return <CampaignsTable />
}
